export default __webpack_public_path__ + "static/Advanced_Sniper_Bullet-9dafb44d2c77903ebd13527a5f94f4b1.png";